export default {
  connection: (state) => state.connection,
  syncRun: (state) => state.syncRun,
  runs: (state) => state.runs,
  issues: (state) => state.issues
};
